import { PriceLabelEnum } from '@/enums/PriceLabelEnum'
import { defaultZodCatch } from '@/lib/converters/defaultZodCatch'
import { zPriceTypeEnum2 } from '@/schemas/priceTypeEnum2Schema'

import type { PriceTypeEnum2 as ResponseDto } from '@/gen/bff'
import type { PriceTypeEnum2Schema } from '@/schemas/priceTypeEnum2Schema'

export const priceTypeEnum2Converter = (data?: ResponseDto): PriceTypeEnum2Schema => {
  const response: PriceTypeEnum2Schema = (() => {
    switch (data) {
      case 'PRICE_LIST': {
        return PriceLabelEnum.PRICE_LIST
      }
      case 'APPROPRIATION': {
        return PriceLabelEnum.APPROPRIATION
      }
      case 'POSITIVE_LIST': {
        return PriceLabelEnum.POSITIVE_LIST
      }
      case 'AGREEMENT': {
        return PriceLabelEnum.AGREEMENT
      }
      case 'CAMPAIGN': {
        return PriceLabelEnum.CAMPAIGN
      }
      default:
        return PriceLabelEnum.PRICE_LIST
    }
  })()

  return zPriceTypeEnum2.catch(defaultZodCatch).parse(response)
}
